/**
 * @param {jQuery} $
 * @param {AppConfig} config
 * @param {AppLibrary} library
 * @constructor
 */
export let TabHistory = function ($, config, library) {
  /**
   * @type {string}
   */
  let rowsTemplate = `
{{#rewards}}
    <tr>
        <td>{{date}}</td>
        <td>{{way_getting}}</td>
        <td style="text-align: center;">{{&amount}}</td>
    </tr>
{{/rewards}}
{{^rewards}}
    <tr>
        <td class="spl-default" colspan="3" style="text-align:center; width:100%;">
            {{&defaultRow}}
        </td>
    </tr>
{{/rewards}}`;

  /**
   * @type {string}
   */
  let amountTemplate = `<span class="{{class}}"><span>{{arrow}}</span><span>{{amount}}</span></span>`;
  /**
   * @type {string}
   */
  let pagerTemplate = `
<nav data-spl-tab-body="pager" aria-label="Page navigation">
    <ul class="slp-pagination slp-justify-content-center">
        <li class="slp-page-item">
            <a class="slp-page-link {{previous.class}}" href="#" data-tabindex="-1" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
                <span class="slp-sr-only">Previous</span>
            </a>
        </li>
        {{#pages}}
            <li class="slp-page-item {{class}}">
                <a data-page="{{value}}" class="slp-page-link" href="#">{{value}}</a>
            </li>
        {{/pages}}
        <li class="slp-page-item">
            <a class="slp-page-link {{next.class}}" href="#" aria-label="Next" data-tabindex="1">
                <span aria-hidden="true">&raquo;</span>
                <span class="slp-sr-only">Next</span>
            </a>
        </li>
    </ul>
</nav>`;

  /**
   * @type {string}
   */
  let template = `
<div class="slp-header">
        <h3>
            `+ config.getPopupText().currentPointsBalance + `: {{points_balance}}
        </h3>
</div>
<div class="slp-header">
    <nav class="slp-navbar">
        <form class="slp-form-inline slp-navbar-nav">
            <div class="slp-form-group slp-mb-2">
                <label for="search_refine_by" class="slp-mr-sm-2 slp-nav-link">`+ config.getPopupText().historySortBy +`</label>
                <select class="slp-form-control slp-mr-sm-2" id="search_refine_by" aria-label="Search">
                    <option value="date">`+ config.getPopupText().historyDate +`</option>
                    <option value="way_getting">`+ config.getPopupText().historyType +`</option>
                    <option value="amount">{{point_plural_name}}</option>
                </select>
            </div>
            <div class="slp-form-group slp-mb-2">
                <label for="search_for" class="slp-mr-sm-2 slp-nav-link">`+ config.getPopupText().historyShow+`</label>
                <select class="slp-form-control slp-mr-sm-2" id="search_for" aria-label="Search">
                    <option value="0">`+ config.getPopupText().historyAllTime +`</option>
                    <option value="180">180 `+ config.getPopupText().historyDays +`</option>
                    <option value="90">90 `+ config.getPopupText().historyDays +`</option>
                    <option value="30">30 `+ config.getPopupText().historyDays +`</option>
                    <option value="7">7 `+ config.getPopupText().historyDays +`</option>
                </select>
            </div>
        </form>
    </nav>
</div>
    <div class="slp-table-container">
        <table class="slp-table slp-table-bordered" data-spurit-slp-customer-account='table'>
            <thead>
            <tr class="slp-bg-primary">
                <th style="width:33%;" scope="col">`+ config.getPopupText().historyDate+`</th>
                <th style="width:33%;" scope="col">`+ config.getPopupText().historyType+`</th>
                <th style="width:34%; text-align: center" scope="col">{{point_plural_name}}</th>
            </tr>
            </thead>
            <tbody>
            
            </tbody>
        </table>
    </div>`;
  /**
   * @type string
   */
  const url = config.env().appApiUrl + '/account';

  /**
   * @type boolean
   */
  let inProcess = false;

  /**
   * @type boolean
   */
  let get = false;

  /**
   * @type object
   */
  const selectors = {
    table: '[data-spurit-slp-customer-account="table"]',
    pager: '[data-spl-tab-body="pager"]',
    root: '[data-spl-tab-body="history"]',
    order: '#search_refine_by',
    period: '#search_for',
  };

  /**
   * @type {{tab: string, heading: string}}
   */
  let texts = config.getTexts().popup_pages.text.history;

  /**
   * @type {{get: function, set: function, getAll: function, unset: function, handler: function}}
   */
  let paging = {

    root: (root) => {
      return root.querySelector(selectors.pager);
    },
    get: (pager, index) => {
      return pager.querySelector('[data-page="' + index + '"]');
    },
    set: (link) => {
      $(link).parent('li').addClass('active');
    },
    getAll: (pager) => {
      return $(pager.querySelectorAll('li a'));
    },
    unset: (links) => {
      $(links).parent('li').removeClass('active');
    },
    handler: (root, order, period, page, pages) => {
      let pager = paging.root(root);
      paging.set(paging.get(pager, page));
      let pageLinks = paging.getAll(pager);
      pageLinks.on('click', function (e) {
        e.preventDefault();
        let next = null;
        if (typeof this.dataset.tabindex !== 'undefined') {
          let tabIndex = +this.dataset.tabindex;
          if ((tabIndex === -1 && page > 1) || (tabIndex === 1 && page !== pages)) {
            tabIndex = page + tabIndex;
            paging.get(pager, tabIndex).click();
          }
        } else if (this.dataset.page !== page) {
          next = this;
          paging.unset(pageLinks);
          paging.set(next);
          getData(root, order, period, +this.dataset.page);
        }
      });
    }
  };

  /**
   * @param root:object
   * @param order:string
   * @param period:number
   * @param page:number
   */
  let getData = (root, order = 'date', period = 0, page = 1) => {
    let
      table = root.querySelector(selectors.table),
      tBody = table.querySelector('tbody'),
      loader = document.createElement('div'),
      rewards = null,
      pages = {
        previous: {
          class: 'disabled',
        },
        next: {
          class: 'disabled',
        },
        numbers: []
      };
    if (!inProcess) {
      $.ajax({
        type: 'GET',
        url: url,
        dataType: 'json',
        data: {
          order: order,
          period: period,
          customer_id: config.getCustomer().id,
          page: page,
        },
        crossDomain: true,
        xhrFields: {
          withCredentials: false
        },
        beforeSend: function () {
          inProcess = true;
          table.className += ' loading';
          if (!get) {
            table.className += ' spl-first';
          }
          loader.className = 'slp-loader';
          tBody.innerHTML += library.mustache().render(
            config.customization().tabHistoryTemplateRows || rowsTemplate, {
              rewards: null,
              defaultRow: loader.outerHTML,
            });
        },
        error: function (jqXHR, textStatus) {
          let message = textStatus;
          if (jqXHR.hasOwnProperty('responseText')) {
            let responseText = JSON.parse(jqXHR.responseText);
            if (responseText.hasOwnProperty('message')) {
              message = responseText.message;
            }
          }
          console.log(message);
        },
        success: function (response) {
          if (response.hasOwnProperty('table')) {
            const types = config.rewardNames();
            for (let i = 0; i < response.table.length; i++) {
              if (typeof response.table[i] === 'object') {
                for (let field in response.table[i]) {
                  if (response.table[i].hasOwnProperty(field)) {
                    if (field === 'way_getting') {
                      if (types.hasOwnProperty(response.table[i][field])) {
                        response.table[i][field] = types[response.table[i][field]];
                      } else if (response.table[i][field] === 'used') {
                        if (response.table[i].hasOwnProperty('used_type')) {
                          response.table[i][field] = response.table[i]['used_type'] ?
                            config.getPopupText().tabHistoryChargePurchase :
                            config.getPopupText().tabHistoryChargeExpired;
                        }
                      }
                    } else if (field === 'amount') {
                      let options = {
                        class: '',
                        arrow: '',
                        amount: Math.abs(response.table[i][field]),
                      };
                      if (response.table[i][field] > 0) {
                        options.class = 'slp-up';
                        options.arrow = '▲';
                      } else if (response.table[i][field] !== 0) {
                        options.class = 'slp-down';
                        options.arrow = '▼';
                      }
                      response.table[i][field] = library.mustache().render(
                        amountTemplate,
                        options
                      );
                    }
                  }
                }
              }
            }
            rewards = response.table;
          }
          if (response.hasOwnProperty('pages') && response.pages > 1) {
            for (let i = 0; i < response.pages; i++) {
              let current = i + 1, active = '';
              if (current === page) {
                active = 'active';
                let prev = page - 1, next = page + 1;
                prev = (prev < 1) ? prev : 0;
                next = (next < response.pages) ? next : response.pages;
                if (prev) {
                  pages.previous.class = 'disabled';
                }
                if (next === response.pages) {
                  pages.next.class = 'disabled';
                }
              }
              pages.numbers.push({
                value: current,
                class: active,
              });
            }
          }
        },
        complete: function () {
          $(loader).fadeOut(300, function () {
            $(this).closest().remove();
            $(table).removeClass('loading')
              .removeClass('spl-first');
            tBody.innerHTML = library.mustache().render(
              config.customization().tabHistoryTemplateRows || rowsTemplate,
              {
                rewards: rewards,
                defaultRow: config.customization().tabHistoryEmpty || config.getPopupText().tabHistoryEmpty,
              });
            let pager = paging.root(root);
            if (pager) {
              pager.remove();
            }
            if (pages.numbers.length) {
              table.outerHTML += library.mustache().render(
                config.customization().tabHistoryTemplatePager || pagerTemplate,
                {
                  pages: pages.numbers,
                  next: pages.next,
                  previous: pages.previous,
                });
              paging.handler(root, order, period, page, pages.numbers.length);
            }
            inProcess = false;
            get = true;
          });
        }
      });
    }
  };

  /**
   * @return {string}
   */
  this.getTitle = () => {
    return texts;
  };

  /**
   * @return {string}
   */
  this.getBody = () => {
    return library.mustache().render(
      config.customization().tabHistoryTemplate || template,
      {
        point_plural_name: config.getPointNames().plural,
        points_balance: config.snippet().customer.balance
      }
    );
  };

  /**
   *@param {HTMLElement} container
   */
  this.afterDisplay = (container) => {
    let root = container.querySelector(selectors.root),
      order = root.querySelector(selectors.order),
      period = root.querySelector(selectors.period);
    getData(root);
    period.onchange = () => {
      getData(root, order.value, period.value);
    };
    order.onchange = () => {
      getData(root, order.value, period.value);
    };
  };
};